import React from "react";
import {Helmet} from "react-helmet";

export default function BatAndHorse() {
    return (
        <div>
            <Helmet>
                <title>无情地简化 Relentlessly Simplify</title>
            </Helmet>
            <h6 className="App-essay-title">无情地简化</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二五 十一月</b>
                <br/><br/>
                我很喜欢Derek Sivers的文风，因为他不仅善于观察，他的文章也是无情简化后的成果，没有废话，没有无病呻吟，没有意义的文字会被删除，只剩下最简单的词汇，描述最有力的观点。
                <br/><br/>
                <i style={{ color: 'grey' }}>
                    A database is just an organized collection of information.<br/>
                    数据库只是一个把信息整理好的盒子。——Derek Sivers
                </i>
                <br/><br/>
                Derek Sivers是谁？之前我分享并翻译过他的一篇文章：<a href="https://www.kunchengblog.com/essay/mob" rel="noreferrer noopener" target="_blank">“我怀念黑帮年代 I miss the mob”</a>
                <br/><br/>
                Derek是音乐家，自学的程序员，作家，和随性的创业者。他1998年创办了CD Baby，后在2008年卖掉收获2200万美元，然后他把这笔钱捐给了慈善机构。这几年，他在新西兰过着半隐居的生活。
                <br/><br/>
                几周前，我和Derek通邮件，他的语言保持一贯的简洁优雅。他很高兴我翻译他的文章并放在我的博客上，还把他写过的全部书籍免费送给我。我们的沟通简单直白，这是我印象中互联网本该有的样子。
                <br/><br/>
                当一个人对一件事思绪不清或理解不深时，TA所说的话和所写的东西，就会充斥着莫名其妙的抽象名词和复杂观点。这是对别人的不尊重。要求自己无情地简化所有观点，也是对自己观点的尊重——清晰的思考，三言两语就能讲清楚；但含混不清的念头，写多少废话都不够。
                <br/><br/>
                学生时代的一堂课只有45分钟，大学里长达几个钟头的大课，也会被分成几十分钟的几堂小课（如果不这么做，你可以看看教室里最后剩下几个人）。人们并非不想把这群孩子关得更久，但更有可能的是，实践中我们发现人的专注力最多只有半个钟头，45分钟已经是连续沟通交流的极限了。
                <br/><br/>
                所以人们也讨厌超过半个小时的会议。能三言两语把事情讲明白，需要人们能无情地简化自己的观点。但大多数人都不具备这个能力，也缺乏对他人和自己的尊重。
                <br/><br/>
                会议的效率随着会议时长的增加而递减，不仅因为人的专注力在下降，还因为我们大概率不是外交部或联合国，需要彰显流程正确和排场宏大。所以，任何超过半个钟头的工作会议，一定有相当大的时间在瞎扯，或者隐晦地宣誓上下级关系。
                <br/><br/>
                如果人们真想促进工作效率，走廊和茶水间的放松闲聊，比几个钟头的会议有效得多。但这种能力比开会稀有得多，因为你得保证对方愿意和你聊天，拥有魅力有时候比保持简洁还难。后者可以训练，而前者需要真诚。
                <br/><br/>
                沟通不需要流程正确和排场宏大，人们需要的只是简洁明了的信息，仅此而已。如果我无法用最简单的语言描述一样东西，那说明我根本不懂这个东西。
                <br/><br/>
                美的东西都很简洁，而丑陋，各有各的复杂。


            </p>

            <br/>

            <h6 className="App-essay-title">Relentlessly Simplify</h6>
            <p className="App-essay-article">
                <br/>
                <b>Nov 2025</b>
                <br/><br/>

            </p>
        </div>)
}
